import 'arrive'
import $ from 'jquery';

document.arrive('.swiper-slide.modal-enabled', {existing: true}, function() {

  const trigger = this;
  const modalId = trigger.dataset.modalid;
  const modal =  $('#' + modalId + ' .modal-with-content');
  const overlay = modal.find('.modal-with-content__overlay');
  const closeButton = modal.find('.btn-close-modal');
  let modalOpen = false;

  $(trigger).on('keydown click', function(e) {
    if (e.type == 'keydown' && e.code !== 'Space' && e.code !== 'Enter') return;
    if (!modalOpen) {
      modal.addClass('show');
      modal.focus();
      modal.get( 0 ).scrollTop = 0;
      document.querySelector('html').style.overflow = 'hidden';
      e.stopPropagation();
      e.preventDefault();
      modalOpen = true;
    }
  });

  [overlay, closeButton].forEach((el) => {
    $(el).on('click', function(e) {
      if (modalOpen) {
        modal.removeClass('show');
        document.querySelector('html').style.overflow = '';
        e.stopPropagation();
        e.preventDefault();
        $(trigger).focus();
        modalOpen = false;
      }
    });
  });

  $(document).on('keydown', function(e) {
      if (e.key === 'Escape') {
          if (modalOpen) {
            modal.removeClass('show');
            document.querySelector('html').style.overflow = '';
            e.stopPropagation();
            e.preventDefault();
            $(trigger).focus();
            modalOpen = false;
          }
      }
  });
});